import axios from "axios";
import Toaster from "../components/Toaster";
import { API_BASE_URL } from "../configs/constant";

axios.defaults.baseURL = `${API_BASE_URL}/`;

axios.interceptors.request.use(
  function (config) {
    if (localStorage.auth_token) {
      const auth = `Bearer ${localStorage.auth_token}`;
      config.headers.Authorization = auth;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (err) {
    if (!err.response) {
      const temp = new Error("Request Cancelled");
      return Promise.reject(temp);
    }

    const { data, status } = err.response;
    const error = data;

    switch (status) {
      case 401:
        Toaster.showError(error.message);
        localStorage.clear();
        setTimeout(() => {
          window.location.reload();
        }, 200);
        break;

      case 403:
        Toaster.showError(error.message);
        break;

      case 404:
        Toaster.showError(error.message);
        break;

      case 400:
        Toaster.showError(error.message);
        break;

      case 412:
        if (error.validation) {
          const firstKey = Object.keys(error.validation)[0];
          if (Array.isArray(error.validation[firstKey])) {
            alert(error.validation[firstKey][0]);
          } else {
            alert(error.validation[firstKey]);
          }
        } else if (error.message) {
          Toaster.showError(error.message);
        } else {
          alert("Something went wrong");
        }
        break;

      case 500:
        Toaster.showError(error.message);
        break;

      default:
        return Promise.reject(error);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axios;
